module.exports = __webpack_public_path__ + "media/img/prod-3-cfb81050.jpg";